module.exports = __webpack_public_path__ + "img/logo.120f2997.png";